/**
 * Created by slava on 23.03.17.
 */

cleverapps.BoardView = cc.Node.extend({
    ctor: function (board, options) {
        this._super();

        this.board = board;
        this.coins = {};
        this.stars = {};
        this.letters = {};
        this.highlightedShine = {};
        this.highlightedLetters = {};
        this.options = options || {};

        this.setAnchorPoint(0.5, 0.5);
        this.setGrid(this.board.gridType === "crossword" ? cleverapps.CrosswordGrid : cleverapps.WordPerlineGrid);
        this.createBackground();

        if (board.game.currentHighlighter) {
            this.currentHighlighterView = new CurrentHighlighterView(board.game.currentHighlighter, this);
            this.grid.addChild(this.currentHighlighterView);
        }

        const eyeBooster = cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_EYE);

        if (eyeBooster) {
            this.eyeBoosterView = new EyeBoosterView(eyeBooster, this);
            this.grid.addChild(this.eyeBoosterView);
        }

        if (board.levelContent.hint) {
            const hintView = this.hintView = new HintView(board.levelContent.hint);
            this.boardBg.addChild(hintView);
        }

        this.visible = false;
        board.on("beforeDiscover", this.beforeDiscover.bind(this), this);
        board.on("afterDiscover", this.afterDiscover.bind(this), this);
        board.on("addCoin", this.addCoin.bind(this), this);
        board.on("collectCoin", this.collectCoin.bind(this), this);
        board.on("addStar", this.addStar.bind(this), this);
        board.on("collectStar", this.collectMissionReward.bind(this), this);
        board.on("lastWord", this.animateLastWord.bind(this), this);
        board.on("alreadyDiscovered", this.animateAlreadyDiscovered.bind(this), this);
        board.on("showUp", this.showUpAnimation.bind(this), this);
        board.on("showUpLetters", this.showUpLettersAnimation.bind(this), this);
        board.on("showUpCoins", this.showUpCoinsAnimation.bind(this), this);
        board.on("showUpStars", this.showUpStarsAnimation.bind(this), this);
        board.on("hide", this.hideAnimation.bind(this), this);
        board.on("openLetter", this.animateOpenLetter.bind(this), this);
        board.on("highlightLetter", this.highlightLetter.bind(this), this);
        board.on("clearHighlight", this.clearHighlight.bind(this), this);
        board.on("setColumnsAmount", this.setColumnsAmount.bind(this), this);

        board.getView = this.createListener(function () {
            return this;
        }, this);
    },

    setGrid: function (GridClass) {
        if (this.grid) {
            this.removeChild(this.grid);
        }

        this.grid = new GridClass(this.board.field);
        this.addChild(this.grid);
    },

    setColumnsAmount: function (columnsCount) {
        if (this.grid.setColumnsAmount) {
            this.grid.setColumnsAmount(columnsCount);
            this.updateHighlightLetter();
        }
    },

    updateGrid: function (availableRect) {
        const styles = cleverapps.styles.BoardView;
        const padding = cc.padding(styles.Background.padding);

        if (this.playersView) {
            padding.top += this.playersView.height;
        }

        const gridRect = cc.rectSubPadding(availableRect, padding);

        if (this.grid.updateGrid) {
            this.grid.updateGrid(gridRect);
        }

        cleverapps.UI.fitToBox(this.grid, Object.assign(gridRect, {
            maxScale: cleverapps.Board.MAX_SCALE[cleverapps.resolution.mode]
        }));

        this.setContentSize(availableRect.width, availableRect.height);
        this.setAlignment(availableRect.x + availableRect.width / 2, availableRect.y + availableRect.height / 2);

        this.grid.setAlignment(this.width / 2, (this.height - padding.top - padding.bottom) / 2 + padding.bottom);
        this.updateHighlightLetter();
    },

    elementsHide: function () {
        Object.values(this.coins).forEach((view) => {
            const scale = view.getScale();
            view.runAction(new cc.Spawn(
                new cc.CallFunc(() => {
                    view.setTimeScale(1);
                    view.setAnimation(0, "fadeout", false);
                }),
                new cc.ScaleTo(0.3, scale * 0.7)
            ));
        });

        const views = Object.values(this.stars)
            .concat(Object.values(this.letters))
            .concat(Object.values(this.grid.listCells(cleverapps.Board.PLACEHOLDER_LAYER)));

        views.forEach((view) => {
            view.stopAllActions();
            const scale = view.getScale();
            if (view.highlightAnimation) {
                view.setOpacity(255);
                view.highlightAnimation.removeFromParent();
            }
            view.runAction(new cc.Spawn(
                new cc.FadeOut(0.3),
                new cc.ScaleTo(0.3, scale * 0.7)
            ));
        });
    },

    hideAnimation: function (f) {
        this.elementsHide();
        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.CallFunc(() => {
                this.setVisible(false);
                f();
            })
        ));
    },

    updateBackground: function () {
        const styles = cleverapps.styles.BoardView;

        const padding = cc.padding(styles.Background.padding);
        const scale = this.grid.getScale();

        let width = this.grid.width * scale + padding.left + padding.right;
        if (styles.Background.width === "100%") {
            width = cleverapps.resolution.getSceneSize().width * 1.05;
        }

        let height = this.grid.height * scale + padding.top + padding.bottom;
        if (this.playersView) {
            height += this.playersView.height;
        }

        if (this.boardBg) {
            this.boardBg.setContentSize2(width, height);
            this.boardBg.setAlignment(this.width / 2, this.height / 2);
        }

        if (this.bgTop) {
            this.bgTop.setContentSize2(width, this.bgTop.height);
            this.bgTop.setAlignment(styles.BgTop);
        }
    },

    createBackground: function () {
        const boardBgImg = (this.board.level.isHard() && bundles.game.frames.hard_board_png) || bundles.game.frames.board_png;
        if (boardBgImg) {
            this.boardBg = cleverapps.UI.createScale9Sprite(boardBgImg);
            this.addChild(this.boardBg);
            this.boardBg.setLocalZOrder(-1);
        }
    },

    animateAlreadyDiscovered: function (indexes) {
        const shake = function (element) {
            if (!element || !element.isRunning()) {
                return;
            }
            const position = element.getPosition();
            const dx = cleverapps.styles.BoardView.shakeAnimation.dx;
            element.runAction(new cc.Sequence(
                new cc.MoveTo(0.06, position.x - dx, position.y).easing(cc.easeIn(1)),
                new cc.MoveTo(0.06, position.x + dx, position.y).easing(cc.easeIn(1)),
                new cc.MoveTo(0.06, position.x - dx, position.y).easing(cc.easeIn(1)),
                new cc.MoveTo(0.06, position.x + dx, position.y).easing(cc.easeIn(1)),
                new cc.MoveTo(0.03, position.x, position.y).easing(cc.easeIn(1))
            ));
        };

        indexes.forEach(function (pos) {
            const row = pos[0];
            const col = pos[1];

            shake(this.grid.getCell(row, col));
            shake(this.letters[`${row}_${col}`]);
        }, this);
    },

    animateLastWord: function (indexes) {
        const animatePhantomLetter = function (index) {
            const styles = cleverapps.styles.BoardView.phantomLetter;

            if (!indexes[index]) {
                return;
            }

            const row = indexes[index][0];
            const col = indexes[index][1];

            const phantomLetter = new cc.Sprite(bundles.letters.frames.letter_bg_png);
            phantomLetter.setOpacity(0);
            phantomLetter.setLocalZOrder(5);
            this.grid.putInCell(row, col, phantomLetter);

            animatePhantomLetter(index + 1);

            phantomLetter.runAction(new cc.Sequence(
                new cc.DelayTime(0.2 * index / 2),
                new cc.CallFunc(() => {
                    if (this.board.isComplete()) {
                        phantomLetter.stopAllActions();
                    }
                }),
                new cc.Spawn(
                    new cc.FadeTo(0.2, styles.opacity),
                    new cc.MoveBy(0.2, 0, styles.dy)
                ),
                new cc.Spawn(
                    new cc.MoveBy(0.2, 0, -styles.dy),
                    new cc.FadeOut(0.2)
                ),
                new cc.RemoveSelf()
            ));
        }.bind(this);

        const animateLine = function (actionIndex) {
            if (!Game.currentGame || Game.currentGame.outcome !== undefined || this.board.isComplete()) {
                return;
            }
            cleverapps.effects.fire("board.word.last");
            animatePhantomLetter(actionIndex);

            this.runAction(
                new cc.Sequence(
                    new cc.DelayTime(10.0),
                    new cc.CallFunc(() => {
                        animateLine(0);
                    })
                )
            );
        }.bind(this);

        this.runAction(
            new cc.Sequence(
                new cc.DelayTime(2.0),
                new cc.CallFunc(() => {
                    animateLine(0);
                })
            )
        );
    }
});

cleverapps.BoardView.prototype.addStar = function (row, col) {
    const starFrames = this.getStarFrames();

    const type = PseudoRandom.GET().random(0, starFrames.length - 1);
    const icon = new cc.Sprite(cleverapps.skins.getSlot("missionStar", { type }) || bundles.game.frames[`mission_star${type}_png`]);

    this.stars[`${row}_${col}`] = icon;

    this.grid.putInCell(row, col, icon);
    icon.setLocalZOrder(6);
};

cleverapps.BoardView.prototype.getStarFrames = function () {
    const starFrames = [];
    for (let i = 0; ;i++) {
        const frame = bundles.game.frames[`mission_star${i}_png`];
        if (!frame) {
            break;
        }

        starFrames.push(frame);
    }

    return starFrames;
};

cleverapps.BoardView.prototype.addCoin = function (row, col) {
    const coinId = `${row}_${col}`;
    const coin = this.coins[coinId] = new cleverapps.Spine(bundles.game.jsons.coin_json);
    coin.order = col;
    coin.setAnchorPoint(0.5, 0.5);
    coin.setAnimation(0, "shine", true);
    coin.setTimeScale(0.5 + Math.random());
    coin.setAnchorPoint(0.5, 0.47);
    this.grid.putInCell(row, col, coin);
    coin.setLocalZOrder(6);
};

cleverapps.BoardView.prototype.collectCoin = function (row, col, reward) {
    const coinId = `${row}_${col}`;
    const coin = this.coins[coinId];
    delete this.coins[coinId];

    if (!coin) {
        return;
    }

    reward.collectRewardsAnimation(coin, {
        flyingAnimation: Reward.COLLECT_ANIMATION,
        withoutDelta: true
    });
};

cleverapps.BoardView.prototype.collectMissionReward = function (row, col) {
    const id = `${row}_${col}`;
    const star = this.stars[id];
    delete this.stars[id];

    if (!star) {
        return;
    }

    MissionCollectDelta.showOver(Mission.TYPE_LIGHTNING_RUSH, 1, star);

    star.runAction(
        new cc.Sequence(
            StandartAnimations.animateCollect(star, `mission_reward${Mission.TYPE_LIGHTNING_RUSH}`, {
                duration: cleverapps.Board.FLIGHT_DURATION / 1000
            }),
            new cc.RemoveSelf()
        )
    );

    star.runAction(new cc.RepeatForever(
        new cc.RotateBy(0.5, 360)
    ));
};

cleverapps.BoardView.prototype.createLetter = function (char, options) {
    options = options || {};

    if (!cleverapps.styles.BoardView.placeHolder.openBg) {
        options.noBg = true;
    }

    options.font = cleverapps.styles.FONTS.BOARD_TEXT;
    return CharView.Create(char, options);
};

cleverapps.BoardView.prototype.playOpenLetterSound = cleverapps.throttle(0.1, () => {
    cleverapps.effects.fire("board.letter");
});

cleverapps.BoardView.prototype.beforeDiscover = function () {};

cleverapps.BoardView.prototype.afterDiscover = function (word, silent, callback) {
    callback = callback || function () {};

    if (silent) {
        callback();
        return;
    }

    this.runAction(
        new cc.Sequence(
            cleverapps.effects.fireAction("board.letters"),
            new cc.DelayTime(0.1),
            new cc.CallFunc(callback)
        )
    );
};

cleverapps.BoardView.prototype.animateOpenLetter = function (row, col, options, callback) {
    callback = callback || function () {};

    const letter = this.board.field[row].charAt(col);

    if (options.silent) {
        this.addLetter(letter, row, col);
        callback();
        return;
    }

    switch (options.type) {
        case cleverapps.Board.HINT_LETTER_ANIMATION:
            this.animateHintLetter(letter, row, col);
            break;

        case cleverapps.Board.DISCOVER_LETTER_ANIMATION:
            if (cleverapps.config.name === "olympics") {
                this.animateDiscoverLetter(letter, row, col, options.index, callback);
            } else {
                this.animateFlyLetter(letter, row, col, callback);
            }
            break;

        case cleverapps.Board.SPAWN_LETTER_ANIMATION:
            this.spawnLetter(letter, row, col, callback);
    }
};

cleverapps.BoardView.prototype.animateDiscoverLetter = function (letter, row, col, index, callback) {
    const delay = index * 0.07;
    const placeholder = this.grid.getCell(row, col, cleverapps.Board.PLACEHOLDER_LAYER);
    const letterSprite = this.addLetter(letter, row, col);
    letterSprite.setVisible(false);

    const letterAction = new cc.Sequence(
        new cc.ScaleTo(0, 0.1, 1.05),
        new cc.Show(),
        new cc.ScaleTo(0.2, 1)
    );

    placeholder.runAction(
        new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.ScaleTo(0.2, 0.1, 1.05),
            new cc.CallFunc(() => {
                placeholder.setSpriteFrame(bundles.letters.frames.letter_bg_png);
            }),
            new cc.Spawn(
                new cc.CallFunc(() => {
                    letterSprite.runAction(letterAction).setFinalize(() => {
                        letterSprite.setScale(1);
                    });
                }),
                new cc.DelayTime(letterAction.getDuration()),
                new cc.ScaleTo(0.2, 1)
            ),
            new cc.CallFunc(callback)
        )
    );

    this.playOpenLetterSound();
};

cleverapps.BoardView.prototype.spawnLetter = function (letter, row, col) {
    const letterSprite = this.createLetter(letter);
    letterSprite.setAnchorPoint(0.5, 0.49);
    this.grid.putInCell(row, col, letterSprite, row, cleverapps.Board.LETTER_LAYER);
    letterSprite.setVisible(false);
    letterSprite.runAction(
        new cc.Sequence(
            StandartAnimations.showUp(letterSprite, { flash: true }),
            new cc.CallFunc(() => {
                this.addLetter(letter, row, col);
            }),
            new cc.RemoveSelf()
        )
    );

    this.playOpenLetterSound();
};

cleverapps.BoardView.prototype.animateHintLetter = function (letter, row, col, start) {
    const target = this.grid.getCell(row, col, cleverapps.Board.LETTER_LAYER);
    if (!target) {
        return;
    }

    const letterSprite = this.createLetter(this.board.field[row].charAt(col));

    letterSprite.runAction(new cc.Sequence(
        cleverapps.UI.animateLetterHintFly(target, letterSprite, {
            start,
            letterZOrder: row
        }),
        new cc.CallFunc(() => {
            this.addLetter(letter, row, col);
        }),
        new cc.RemoveSelf()
    ));
};

cleverapps.BoardView.prototype.addLetter = function (letter, row, col) {
    const letterSprite = this.createLetter(letter, { noBg: true });
    letterSprite.setAnchorPoint(0.5, 0.49);

    if (this.grid.isExistsCell(row, col)) {
        this.grid.putInCell(row, col, letterSprite, row, cleverapps.Board.LETTER_LAYER);

        const letterId = `${row}_${col}`;
        this.letters[letterId] = letterSprite;

        if (cleverapps.styles.BoardView.placeHolder.openBg) {
            const placeholder = this.grid.getCell(row, col, cleverapps.Board.PLACEHOLDER_LAYER);
            placeholder.setSpriteFrame(cleverapps.styles.BoardView.placeHolder.openBg);
        }

        return letterSprite;
    }
};

cleverapps.BoardView.prototype.animateFlyLetter = function (letter, row, col, callback) {
    const letterView = this.board.game.current.getLetterView(letter);

    this.playOpenLetterSound();

    if (!letterView || !letterView.isRunning()) {
        this.addLetter(letter, row, col);
        callback();
        return;
    }

    const target = this.grid.getCell(row, col, cleverapps.Board.LETTER_LAYER);

    letterView.stopAllActions();
    letterView.setOpacity(255);
    letterView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this), {
        keepScale: true
    });

    const letterPosition = letterView.getPosition();
    const targetPosition = target.getPosition();

    const first = letterPosition;
    const third = letterView.getParent().convertToNodeSpace(target.getParent().convertToWorldSpace(targetPosition));
    const second = cc.p((first.x + 2 * third.x) / 3, (first.y + 2 * third.y) / 3 - 10);
    const flyTime = cc.pDistance(first, third) / 1750;

    const shine = new cleverapps.Spine(bundles.game.jsons.letter_particle);
    shine.setAnimation(0, "animation", false);
    shine.setPosition(letterView.width / 2, letterView.height / 2);
    shine.setLocalZOrder(1);
    letterView.addChild(shine);

    letterView.runAction(new cc.Sequence(
        new cc.DelayTime((PseudoRandom.GET().random(0, 200)) / 1000),
        new cc.Spawn(
            new cc.BezierTo(flyTime, [first, second, third]).easing(cc.easeInOut(1)),
            new cc.ScaleTo(flyTime, 1).easing(cc.easeInOut(1))
        ),
        new cc.CallFunc(() => {
            const letterView = this.addLetter(letter, row, col);
            const placeholder = this.grid.getCell(row, col, cleverapps.Board.PLACEHOLDER_LAYER);
            letterView.runAction(new cc.Sequence(
                new cc.ScaleTo(0.13, 1.2).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.13, 1).easing(cc.easeInOut(1))
            ));
            placeholder.runAction(new cc.Sequence(
                new cc.ScaleTo(0.13, 1.2).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.13, 1).easing(cc.easeInOut(1))
            ));
        }),
        new cc.Hide(),
        new cc.DelayTime(0.26),
        new cc.CallFunc(callback),
        new cc.RemoveSelf()
    ));

    const letterId = `${row}_${col}`;
    this.letters[letterId] = letterView;
};

cleverapps.BoardView.prototype.highlightLetter = function (row, col) {
    if (this.grid.isExistsCell(row, col)) {
        const letter = this.board.field[row].charAt(col);

        const bgImage = bundles.letters.frames.letter_bg_highlighted_png;

        const letterSprite = this.createLetter(letter, {
            bgImage
        });

        const highlightSprite = new cc.Sprite(bundles.letters.frames.highlighted_png);

        const letterId = `${row}_${col}`;
        this.highlightedLetters[letterId] = letterSprite;
        this.highlightedShine[letterId] = highlightSprite;
        this.grid.addChild(highlightSprite, row - 1);
        this.grid.addChild(letterSprite, row + 1);
    }
};

cleverapps.BoardView.prototype.updateHighlightLetter = function () {
    Object.keys(this.highlightedLetters).forEach((key) => {
        const rowAndCol = key.split("_");
        const row = Number.parseInt(rowAndCol[0]);
        const col = Number.parseInt(rowAndCol[1]);

        const cell = this.grid.getCell(row, col);

        this.highlightedLetters[key].setAlignment(cell.x, cell.y + cleverapps.styles.BoardView.Letter.paddingBottom);
        this.highlightedShine[key].setAlignment(cell.x, cell.y + cleverapps.styles.BoardView.Letter.paddingBottom);
    });
};

cleverapps.BoardView.prototype.clearHighlight = function () {
    Object.keys(this.highlightedLetters).forEach((letterId) => {
        if (this.highlightedLetters[letterId]) {
            this.highlightedLetters[letterId].removeFromParent();
            delete this.highlightedLetters[letterId];
        }

        if (this.highlightedShine[letterId]) {
            this.highlightedShine[letterId].removeFromParent();
            delete this.highlightedShine[letterId];
        }
    });
};

cleverapps.styles.BoardView = {
    minSpaceX: 20,
    maxSpaceX: 100,
    minSpaceY: 10,

    placeHolder: {
        openBg: bundles.letters.frames.letter_bg_png
    },

    Letter: {
        offset: 5,
        paddingBottom: 0
    },
    Coin: {
        paddingBottom: 3,
        showUpOffset: 25
    },
    Background: {
        width: "100%",

        padding: {
            x: 15,
            y: 25
        }
    },
    shakeAnimation: {
        dx: 12
    },
    phantomLetter: {
        opacity: 180,
        dy: 5
    },

    bezier: {
        y: 10
    },

    spawnLetter: {
        x: { align: "center" },
        y: { align: "center" }
    },

    playersView: {
        x: { align: "center" },
        y: { align: "top", dy: 5 }
    }
};
